// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"101":"ad2e88b4","139":"b873f22b","284":"c6c746dc","378":"949bf32e","415":"2588ed98","424":"1666415d","598":"69f863fd","606":"5771488e","736":"5409095f","878":"19672598","930":"462ad249"}[chunkId] + ".js";
};